"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formMap = void 0;
const immer_1 = __importDefault(require("immer"));
const redux_1 = require("redux");
const actions = __importStar(require("../../../../../shared/store/action_constants"));
const index_1 = require("../index");
const form = (state = null, action) => {
    if (action.type === actions.SET_FORM_DATA) {
        return action.payload;
    }
    if (!state) {
        return null;
    }
    switch (action.type) {
        case actions.UPDATE_FORM: {
            return Object.assign(Object.assign({}, state), action.payload);
        }
        case actions.FORM_PROP_UPDATE: {
            return Object.assign(Object.assign({}, state), { snapshot: Object.assign(Object.assign({}, state.snapshot), { formProps: Object.assign(Object.assign({}, state.snapshot.formProps), action.payload) }) });
        }
        case actions.FORM_JOT_ACTION: {
            return (0, immer_1.default)(state, draft => {
                (0, index_1.JOTApply)(draft, action);
                return draft;
            });
        }
        case actions.FORM_UPDATE_REVISION: {
            return Object.assign(Object.assign({}, state), { revision: action.payload });
        }
        case actions.UPDATE_FORM_NAME: {
            state.name = action.payload;
            return state;
        }
        default: {
            return state;
        }
    }
};
const defaultClient = {};
const client = (state = defaultClient, action) => {
    switch (action.type) {
        case actions.FORM_ACTIVE_COLLABORATOR: {
            if (!state.collaborators) {
                return Object.assign(Object.assign({}, state), { collaborators: [action.payload] });
            }
            else if (state.collaborators.find(user => user.socketId === action.payload.socketId)) {
                console.error('warning user enter with same socketid');
                return state;
            }
            state.collaborators = [...state.collaborators, action.payload];
            return state;
        }
        case actions.FORM_DEACTIVATE_COLLABORATOR: {
            if (!state.collaborators) {
                return state;
            }
            state.collaborators = state.collaborators.filter(user => user.socketId !== action.payload.socketId);
            return state;
        }
        case actions.FORM_ROOM_INFO_SYNC: {
            return Object.assign(Object.assign({}, state), { collaborators: action.payload });
        }
        case actions.SET_FORM_CLIENT: {
            return Object.assign(Object.assign({}, state), action.payload);
        }
        default: {
            return state;
        }
    }
};
const formPack = (0, redux_1.combineReducers)({
    loading: (state = false, action) => {
        if (action.type === actions.SET_FORM_LOADING) {
            return action.payload;
        }
        if (action.type === actions.FORM_ERROR_CODE ||
            action.type === actions.SET_FORM_DATA) {
            return false;
        }
        return state;
    },
    connected: (state = false, action) => {
        if (action.type === actions.FORM_CONNECTED) {
            return true;
        }
        return state;
    },
    errorCode: (state = null, action) => {
        if (action.type === actions.FORM_ERROR_CODE) {
            return action.payload;
        }
        if (action.type === actions.SET_FORM_LOADING ||
            action.type === actions.SET_FORM_DATA) {
            return null;
        }
        return state;
    },
    syncing: (state = false, action) => {
        if (action.type === actions.SET_FORM_SYNCING) {
            return action.payload;
        }
        return state;
    },
    form,
    client,
});
const formMap = (state = {}, action) => {
    if (!action.formId) {
        return state;
    }
    if (action.type === actions.RESET_FORM) {
        const newState = Object.assign({}, state);
        delete newState[action.formId];
        return newState;
    }
    return Object.assign(Object.assign({}, state), { [action.formId]: formPack(state[action.formId], action) });
};
exports.formMap = formMap;
//# sourceMappingURL=form.js.map